export function spainProvinces() {
  return [
    {
      "id": 1,
      "nombre": "Álava",
      "estado": 1
    },
    {
      "id": 2,
      "nombre": "Albacete",
      "estado": 1
    },
    {
      "id": 3,
      "nombre": "Alicante/Alacant",
      "estado": 1
    },
    {
      "id": 4,
      "nombre": "Almería",
      "estado": 1
    },
    {
      "id": 5,
      "nombre": "Ávila",
      "estado": 1
    },
    {
      "id": 6,
      "nombre": "Badajoz",
      "estado": 1
    },
    {
      "id": 7,
      "nombre": "Balears, Illes",
      "estado": 1
    },
    {
      "id": 8,
      "nombre": "Barcelona",
      "estado": 1
    },
    {
      "id": 9,
      "nombre": "Burgos",
      "estado": 1
    },
    {
      "id": 10,
      "nombre": "Cáceres",
      "estado": 1
    },
    {
      "id": 11,
      "nombre": "Cádiz",
      "estado": 1
    },
    {
      "id": 12,
      "nombre": "Castellón/Castelló",
      "estado": 1
    },
    {
      "id": 13,
      "nombre": "Ciudad Real",
      "estado": 1
    },
    {
      "id": 14,
      "nombre": "Córdoba",
      "estado": 1
    },
    {
      "id": 15,
      "nombre": "Coruña, A",
      "estado": 1
    },
    {
      "id": 16,
      "nombre": "Cuenca",
      "estado": 1
    },
    {
      "id": 17,
      "nombre": "Girona",
      "estado": 1
    },
    {
      "id": 18,
      "nombre": "Granada",
      "estado": 1
    },
    {
      "id": 19,
      "nombre": "Guadalajara",
      "estado": 1
    },
    {
      "id": 20,
      "nombre": "Gipuzkoa",
      "estado": 1
    },
    {
      "id": 21,
      "nombre": "Huelva",
      "estado": 1
    },
    {
      "id": 22,
      "nombre": "Huesca",
      "estado": 1
    },
    {
      "id": 23,
      "nombre": "Jaén",
      "estado": 1
    },
    {
      "id": 24,
      "nombre": "León",
      "estado": 1
    },
    {
      "id": 25,
      "nombre": "Lleida",
      "estado": 1
    },
    {
      "id": 26,
      "nombre": "Rioja, La",
      "estado": 1
    },
    {
      "id": 27,
      "nombre": "Lugo",
      "estado": 1
    },
    {
      "id": 28,
      "nombre": "Madrid",
      "estado": 1
    },
    {
      "id": 29,
      "nombre": "Málaga",
      "estado": 1
    },
    {
      "id": 30,
      "nombre": "Murcia",
      "estado": 1
    },
    {
      "id": 31,
      "nombre": "Navarra",
      "estado": 1
    },
    {
      "id": 32,
      "nombre": "Ourense",
      "estado": 1
    },
    {
      "id": 33,
      "nombre": "Asturias",
      "estado": 1
    },
    {
      "id": 34,
      "nombre": "Palencia",
      "estado": 1
    },
    {
      "id": 35,
      "nombre": "Palmas, Las",
      "estado": 1
    },
    {
      "id": 36,
      "nombre": "Pontevedra",
      "estado": 1
    },
    {
      "id": 37,
      "nombre": "Salamanca",
      "estado": 1
    },
    {
      "id": 38,
      "nombre": "Santa Cruz de Tenerife",
      "estado": 1
    },
    {
      "id": 39,
      "nombre": "Cantabria",
      "estado": 1
    },
    {
      "id": 40,
      "nombre": "Segovia",
      "estado": 1
    },
    {
      "id": 41,
      "nombre": "Sevilla",
      "estado": 1
    },
    {
      "id": 42,
      "nombre": "Soria",
      "estado": 1
    },
    {
      "id": 43,
      "nombre": "Tarragona",
      "estado": 1
    },
    {
      "id": 44,
      "nombre": "Teruel",
      "estado": 1
    },
    {
      "id": 45,
      "nombre": "Toledo",
      "estado": 1
    },
    {
      "id": 46,
      "nombre": "Valencia/València",
      "estado": 1
    },
    {
      "id": 47,
      "nombre": "Valladolid",
      "estado": 1
    },
    {
      "id": 48,
      "nombre": "Bizkaia",
      "estado": 1
    },
    {
      "id": 49,
      "nombre": "Zamora",
      "estado": 1
    },
    {
      "id": 50,
      "nombre": "Zaragoza",
      "estado": 1
    },
    {
      "id": 51,
      "nombre": "Ceuta",
      "estado": 1
    },
    {
      "id": 52,
      "nombre": "Melilla",
      "estado": 1
    }
  ];
}
